/* 🤖 this file was generated by svg-to-ts */
export const waytrStar = {
    name: 'star',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="M10,4a.48.48,0,0,0-.4-.57L6.74,3,5.45.28a.45.45,0,0,0-.2-.21.5.5,0,0,0-.7.21L3.3,3,.45,3.43a.29.29,0,0,0-.3.16.52.52,0,0,0,0,.73L2.2,6.41l-.5,3a.72.72,0,0,0,.05.32.5.5,0,0,0,.7.21L5,8.51,7.54,9.93a.37.37,0,0,0,.25.05h.1a.55.55,0,0,0,.4-.63l-.5-3L9.84,4.27A.31.31,0,0,0,10,4Z"/></svg>`,
};
